const FORMATO_EMAIL = new RegExp('^[a-zA-Z0-9._-]{2,}[@]{1}[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}$'); //verified
const WHITELIST_TELEFONO = new RegExp('^[0-9\\-/+ \s]*$'); //TODO da perfezionare per accettare il + solo in testa
const FORMATO_CF_PIVA = new RegExp('(^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$)|(^[0-9]{11}$)'); //Gestisce sia CF che P.Iva
const FORMATO_CF = new RegExp('^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$'); //Gestisce CF

const FORMATO_PIVA = new RegExp('^[0-9]{11}$'); //Gestisce P.Iva
const FORMATO_TARGA = new RegExp('^[A-Z]{2}[A-Z0-9]{5,6}$|^[A-Z0-9]{10,17}$|^[A-Z0-9]{2}[P]{1}[A-Z0-9]{4,5}$|^[X]{1}[0-9]{6}$|^[A-Z0]{1}[A-Z0-1]{1}[A-Z0]{1}[A-Z]{3}[A-Z1]{1}$|^[0-9]{2}(MDANY)|(GALLO){1}$');
const FORMATO_IBAN = new RegExp('^[a-zA-Z0-9]{27}$');
const FORMATO_CARATTERE_SINGOLO = new RegExp('^[a-zA-Z]{1}$');
const FORMATO_IMPORTO = new RegExp('^[1-9]{1}[0-9]{1,3}[.,]{1}[0-9]{2}$'); //DF STALIGK-885
const WHITELIST_APPELLATIVO = new RegExp('^[a-zA-ZàáÀÁèéÈÉìíÌÍòóÒÓùúÙÚ\\-\' .,\s]*$'); //TODO check
const WHITELIST_INDIRIZZO = new RegExp('^[a-zA-ZàáÀÁèéÈÉìíÌÍòóÒÓùúÙÚ0-9\\-\'/ .,\s]*$'); //TODO check
const WHITELIST_DATA_CALENDARIO = new RegExp('[0-9\\-]{7,}$'); //accetto solo trattino: è il formato dell' input "date" e "month" di design-react-kit
const WHITELIST_NUMBER = new RegExp('[0-9]{1,}$');
const FORMATO_CAP = new RegExp('^[0-9]{5}$');  
const FORMATO_SCADENZA = new RegExp('^20[0-9]{2,2}-(1[0-2]|0?[1-9])$');

const CHECK_CODE_EVEN = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9, K: 10, L: 11, M: 12, N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19, U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25 };
const CHECK_CODE_ODD = { 0: 1, 1: 0, 2: 5, 3: 7, 4: 9, 5: 13, 6: 15, 7: 17, 8: 19, 9: 21, A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21, K: 2, L: 4, M: 18, N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14, U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23 };
const CHECK_CODE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export function isOmocodia(cf) {
    if(cf){
        if(check(cf)){
            for (const pos of [6, 7, 9, 10, 12, 13, 14]) {
                if (!/^[0-9]$/.test(cf[pos])) return true;
            }
        }
    }
    return false;
}

function check(codiceFiscale) {
    if (typeof codiceFiscale !== 'string') {
      return false;
    }
    let cf = codiceFiscale.toUpperCase();
    if (cf.length !== 16) {
      return false;
    }
    if (!/^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$/.test(cf)) {
      return false;
    }
    const expectedCheckCode = codiceFiscale.charAt(15);
    cf = codiceFiscale.slice(0, 15);
    return getCheckCode(cf).toUpperCase() === expectedCheckCode.toUpperCase();
}

function getCheckCode(codiceFiscale) {
    codiceFiscale = codiceFiscale.toUpperCase();
    let val = 0;
    for (let i = 0; i < 15; i++) {
      const c = codiceFiscale[i];
      val += i % 2 !== 0 ? CHECK_CODE_EVEN[c] : CHECK_CODE_ODD[c];
    }
    val = val % 26;
    return CHECK_CODE_CHARS.charAt(val);
}

export function getValidCfOrEmptyValue(cf) {
    return FORMATO_CF_PIVA.test(cf) || isOmocodia(cf) ? cf.trim() : '';
}

export function getValidTargaOrEmptyValue(targa) {
    return FORMATO_TARGA.test(targa) ? targa.trim() : '';
}

export function getValidEmailOrEmptyValue(email) {
    return FORMATO_EMAIL.test(email) ? email.trim() : '';
}

export function getValidIbanOrEmptyValue(iban) {
    return FORMATO_IBAN.test(iban) ? iban.trim() : '';
}

export function isValidIban(iban, choice) {
    //console.log('isValid IBAN', iban)
    if (iban) {
        iban = iban.replaceAll(' ', '');
        iban = iban.replaceAll('-', '');
    }
    return iban && iban.substring(0,2) === 'IT' && FORMATO_IBAN.test(iban) && FORMATO_CARATTERE_SINGOLO.test(iban.substring(4,5));
}

export function isValidCfOrPiva(idfiscale) {
    return (isValidCf(idfiscale) || isValidPiva(idfiscale));
}


export function isValidCf(idfiscale) {
    return (idfiscale && FORMATO_CF.test(idfiscale)) || (idfiscale && isOmocodia(idfiscale));
}

export function isValidPiva(idfiscale) {
    return idfiscale && FORMATO_PIVA.test(idfiscale);
}

export function isValidTargaOrTelaio(targa) {
    //console.log('isValid targa', targa)
    return targa && FORMATO_TARGA.test(targa);
}

export function isValidEmail(email) {
    //console.log('isValid email', email)
    return email && FORMATO_EMAIL.test(email)
}
//STALIGK-835
export function isValidAndDifferentEmail(newEmail,oldEmail) {
    return newEmail && FORMATO_EMAIL.test(newEmail) && (newEmail != oldEmail)
}

export function isValidIndirizzo(indirizzo) {
    //console.log('isValid indirizzo', indirizzo)
    return indirizzo && WHITELIST_INDIRIZZO.test(indirizzo)
}

export function isValidCivico(civico) {
    //console.log('isValid indirizzo', indirizzo)
    return civico === null || civico === '' || (civico && WHITELIST_INDIRIZZO.test(civico))
}

export function isValidCAP(capRes) {
    return capRes && FORMATO_CAP.test(capRes);
}

export function isValidAppellativo(appellativo) {
    //console.log('isValid appellativo', appellativo)
    return appellativo && true
}

export function isValidProvincia(provincia) {
    //console.log('isValid provincia', provincia)
    return provincia && WHITELIST_APPELLATIVO.test(provincia) && provincia.length <= 4 && provincia.length >= 2;
}

export function isValidTelefono(telefono) {
    //console.log('isValid telefono', telefono)
    return telefono && WHITELIST_TELEFONO.test(telefono)
}

export function isValidData(data) {
    //console.log('isValid data', data)
    return data && WHITELIST_DATA_CALENDARIO.test(data)
}

export function isValidNumber(number) {
    //console.log('isValid number', number)
    return number && WHITELIST_NUMBER.test(number)
}

export function isValidBoolean(boolVal) {
    return (boolVal === true || boolVal === false); //unici due valori consentiti
}

export function isValidCharacter(char) {
    return char && FORMATO_CARATTERE_SINGOLO.test(char)
}

export function isValidScadenza(scadenza) {
    //STALIGK-833 return (scadenza.toString().length === 7 && scadenza.toString().includes('-'));
    return (scadenza.toString().length === 7 && FORMATO_SCADENZA.test(scadenza));
}

export function getValidScadenzaOrEmptyValue(scadenza) {
    return isValidScadenza(scadenza) ? scadenza : '';
}

//STALIGK-833
export function isValidAnnoMeseScadenza(scadenza,inputType) {
    if (inputType === "month") {
        return isValidData(scadenza);
    } else if (inputType === "text") {
        return (scadenza.toString().length === 7 && FORMATO_SCADENZA.test(scadenza));
    }
}

export function isMesiValidità(validita) {
    return (isValidNumber(validita) && (validita >= 2 && validita <= 12));
}
//STALIGK-887
export function isMesiValiditàSottoAlternative(validita, minValidita, maxValidita) {
    console.log("validita:" + validita + " -minValidita:" + minValidita + " -maxValidita:" +maxValidita + "return:" + (validita <= maxValidita && validita >= minValidita));
    return validita && ((validita <= maxValidita) && (validita >= minValidita));
}

export function getValidImportoOrEmptyValue(importo) {
    console.log('getValidImportoOrEmptyValue: importo=', importo)
    const imp = importo.toString();
    if (imp.length <= 7 && ((imp.includes('.') || imp.includes(',')))) {
        const res = imp.replace(',', '.');
        console.log('getValidImportoOrEmptyValue: res=', res)
        return res;
    }
    return '';
}

export function isValidImporto(importo) {
    return importo && FORMATO_IMPORTO.test(importo)
}

